module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            Hapus Invoice\n        ")]), _vm._v(" "), _c('Button-group', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSearch,
      "icon": "ios-search",
      "size": "small"
    },
    on: {
      "click": _vm.getInvoices
    }
  }, [(!_vm.loadingSearch) ? _c('span', [_vm._v("Search")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('Table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoices.length > 0),
      expression: "invoices.length > 0"
    }],
    attrs: {
      "columns": _vm.tableColumns,
      "data": _vm.invoices,
      "no-data-text": ""
    },
    on: {
      "on-row-click": _vm.showDeleteInvoice
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "80%"
    },
    on: {
      "on-cancel": function($event) {
        _vm.confirmMarkingheadercode = ''
      }
    },
    model: {
      value: (_vm.modalConfirmDelete),
      callback: function($$v) {
        _vm.modalConfirmDelete = $$v
      },
      expression: "modalConfirmDelete"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.invoiceToDelete.markingCode) + " : " + _vm._s(_vm.invoiceToDelete.transactionDate))]), _vm._v(" "), _c('p', [_vm._v("Partai " + _vm._s(_vm.invoiceToDelete.description) + " ")]), _vm._v(" "), _c('p', [_vm._v("Invoice Fee     : Rp "), _c('b', [_vm._v(_vm._s(_vm.invoiceToDelete.invoiceFee) + " ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "long": "",
      "loading": _vm.isLoadingDelete
    },
    on: {
      "click": _vm.deleteInvoice
    }
  }, [_vm._v("Hapus")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ead2bdfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/InvoiceDelete.vue
// module id = 1861
// module chunks = 1